var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request-result"},[_c('span',{staticClass:"sp sp1"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"sp sp2",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.btnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }